import api from "../../../../../features/auth/axiosConfig";

export const getEmployees = async () => {
  const res = await api.get(`/pos/get_user`);
  return res.data.result;
};

export const getDeletedEmployees = async () => {
  const res = await api.get(`/pos/add_employee/DeletedUsers`);
  return res.data.result;
};

export const addEmployee = async (data: any) => {
  return api.post(`/pos/add`, data);
};

export const deleteEmployee = async (id: string | number) => {
  return api.delete(`/pos/add/${id}`);
};

export const updateEmployee = async (id: string | number, data: any) => {
  return api.put(`/pos/add/${id}`, data);
};
